// extracted by mini-css-extract-plugin
export default {"tourItem":"Tour_tourItem__uBd0K"};